module.exports = __webpack_public_path__ + "img/geod_7.49a498d2.jpg";